import { Dialog, type ConfirmOptions, type PromptOptions } from '@capacitor/dialog'
import { createLogger } from '@/@vxapp/@core/Logger/VxLog'

const log = createLogger('NativeDialogs')

export interface NativeAlertOptions {
  title: string
  message: string
  buttonTitle?: string
}

export interface NativePromptResult {
  value: string
  cancelled: boolean
}

export async function showNativeAlert(options: NativeAlertOptions): Promise<void> {
  try {
    await Dialog.alert(options)
  } catch (error: unknown) {
    log.error('Native alert could not be displayed', error)
  }
}

export async function showNativeConfirm(options: ConfirmOptions): Promise<boolean> {
  try {
    const result = await Dialog.confirm(options)

    return result.value
  } catch (error: unknown) {
    log.error('Native confirmation could not be displayed', error)

    return false
  }
}

export async function showNativePrompt(options: PromptOptions): Promise<NativePromptResult> {
  try {
    return await Dialog.prompt(options)
  } catch (error: unknown) {
    log.error('Native prompt could not be displayed', error)

    return { value: '', cancelled: true }
  }
}
